export function numberParser(s: string | null): number | undefined {
  if (
    typeof s === "string" &&
    (/^-?\d+$/.test(s) || /^-?\d*\.\d+$/.test(s)) &&
    isNumeric(s)
  ) {
    return parseFloat(s);
  } else {
    return undefined;
  }
}

function isNumeric(s: string | null) {
  return (
    typeof s === "string" && !isNaN(parseFloat(s)) && isFinite(parseFloat(s))
  );
}

export function isInteger(s: string | null): boolean {
  return typeof s === "string" ? /^-?\d+$/.test(s) : false;
}

export function zeroPad(n: number): string {
  if (n < 10) {
    return "0" + n.toString();
  }
  return n.toString();
}
